import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

/**
 * Interceptor to set the actual
 */
@Injectable({ providedIn: 'root' })
export class MockBackendInterceptor implements HttpInterceptor {
    private readonly mockServerUrl = 'https://localhost.sew-d.de:4200';
    private readonly serverUrl = 'https://www.sew-d.de';
    private readonly mockPaths = ['/os/api/ecs', '/os/api/pexw', '/os/api/compare'];

    public intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (
            !this.mockPaths.some((mockPath) => httpRequest.url.includes(mockPath)) ||
            httpRequest.method === 'OPTIONS'
        ) {
            return next.handle(httpRequest);
        }

        const mockUrl = this.getMockUrl(httpRequest.url);

        const mockServerRequest = httpRequest.clone({
            url: mockUrl,
        });

        return next.handle(mockServerRequest).pipe(
            catchError(() => {
                return this.handleMockServerErrorResponse(mockServerRequest, next, httpRequest);
            })
        );
    }

    private getMockUrl(requestUrl: string) {
        const mockUrl = requestUrl;

        return mockUrl.replace(this.serverUrl, this.mockServerUrl);
    }

    private handleMockServerErrorResponse(
        mockServerRequest: HttpRequest<any>,
        next: HttpHandler,
        originalRequest: HttpRequest<any>
    ) {
        console.log(`no mocked endpoint for ${mockServerRequest.url} found. Bypass request to Backend`);

        return next.handle(originalRequest);
    }
}
